(function () {
  /*
   * graceProduce('.js-selector', ClassName, options)
   *
   * to get a instance of the Module ClassName for each DOM element
   * Factory Pattern
   */
  graceProduce('.js-stage-slider', TinySlider, {
    mode: 'gallery',
    controls: false,
    navContainer: '.js-stage-slider-nav',
    autoplay: true,
    autoplayTimeout: 5000,
  });

  graceProduce('.js-quote-slider', TinySlider, {
    mode: 'gallery',
    controls: false,
    navContainer: '.js-quote-slider-nav',
    autoplay: true,
    autoplayTimeout: 5000,
    speed: 1500,
  });

  graceProduce('.js-gallery-slider', TinySlider, {
    controls: false,
    navContainer: '.js-gallery-slider-nav',
    autoplay: true,
    autoplayTimeout: 5000,
    speed: 1500,
    loop: false,
    rewind: true,
    gutter: 16,
    mouseDrag: true,
    clickableSlides: true,
    items: 1.15,
    responsive: {
      1400: {
        items: 1,
      },
    }
  });

  graceProduce('.js-value-slider', TinySlider, {
    items: 1.25,
    nav: false,
    controlsContainer: '.js-value-slider-buttons',
    loop: true,
    rewind: false,
    gutter: 16,
    mouseDrag: true,
    responsive: {
      800: {
        items: 2.5,
      },
      700: {
        items: 2.25,
      }
    }
  });

  graceProduce('.js-story-slider', TinySlider, {
    mode: 'gallery',
    nav: false,
    controlsContainer: '.js-story-slider-buttons',
  });

  if(is_sm_and_smaller()) {
    graceProduce('.js-process-slider', TinySlider, {
      controls: false,
      nav: false,
      loop: false,
      rewind: true,
      items: 1,
      nested: 'inner',
      responsive: {
        600: {
          items: 2,
        },
      }
    });
  }

  graceProduce('.js-list-insight', ListInsight);

  graceProduce('.js-main-navigation', MainNavigation);

  graceProduce('.js-header-bar', HeaderBar);

  graceProduce('.js-tab-element', TabElement);

  graceProduce('.js-event-slider', TinySlider, {
    controls: true,
    controlsContainer: '.js-event-slider-buttons',
    nav: false,
    items: 1,
    loop: false,
    rewind: true,
    mouseDrag: true,
    clickableSlides: true,
    responsive: {
      1200: {
        items: 3,
      },
      600: {
        items: 2,
      }
    }
  });

  graceProduce('.js-open-content-overlay', ContentOverlay);

  graceProduce('.js-isotope-grid', IsotopeGrid);

  graceProduce('.js-accordion-element', Accordion);

  graceProduce('.js-post-grid', PostGrid);

  graceProduce('.js-resource-slider', TinySlider, {
    controls: true,
    controlsContainer: '.js-resource-slider-buttons',
    nav: false,
    items: 1,
    loop: false,
    rewind: true,
    mouseDrag: true,
    clickableSlides: true,
    responsive: {
      1200: {
        items: 3,
      },
      600: {
        items: 2,
      }
    }
  });

  graceProduce('.js-scroll-top-button', ScrollTopButton);

  graceProduce('.js-agile-atoms-insight', AgileAtomInsight);

  graceProduce('.js-exit-intent', ExitIntentOverlay);

  graceProduce('.js-pricing-teaser', PricingTeaser);

  /*
   * graceCreate('.js-selector', ClassName, options)
   *
   * to get one instance of the Module ClassName with each DOM element
   * Singleton Pattern
   */
}());
